module.exports = __webpack_public_path__ + "static/assets/b2bf5d4ea5175c2099d38c338b7a1d9b.png";